import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DebugSchedule = () => {
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSchedules = async () => {
      try {
        console.log('Fetching schedules...');
        
        // Login to get token
        const loginResponse = await axios.post(`${API}/auth/login`, {
          username: 'admin',
          password: 'password'
        });
        
        const token = loginResponse.data.token;
        console.log('Got token:', token.substring(0, 20) + '...');
        
        // Fetch schedules
        const response = await axios.get(`${API}/schedules?date_from=2025-10-06&date_to=2025-10-12`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        console.log('Schedules response:', response.data);
        setSchedules(response.data);
        
      } catch (err) {
        console.error('Error:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    
    fetchSchedules();
  }, []);

  if (loading) return <div className="p-4">Loading...</div>;
  if (error) return <div className="p-4 text-red-500">Error: {error}</div>;

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Debug Schedule Data</h1>
      
      <div className="mb-4">
        <p><strong>Total Schedules:</strong> {schedules.length}</p>
      </div>
      
      {schedules.map((schedule, index) => (
        <div key={schedule.id} className="border p-4 mb-4 rounded">
          <h3 className="font-bold text-lg">Schedule #{index + 1}</h3>
          <p><strong>Employee Name:</strong> {schedule.employee?.name || 'NO NAME'}</p>
          <p><strong>Date:</strong> {schedule.date}</p>
          <p><strong>Time:</strong> {schedule.start_time} - {schedule.end_time}</p>
          <p><strong>Type:</strong> {schedule.shift_type}</p>
          <p><strong>Notes:</strong> {schedule.notes || 'None'}</p>
          
          <div className="mt-2">
            <button 
              onClick={async () => {
                if (window.confirm(`Delete ${schedule.employee?.name}'s shift?`)) {
                  try {
                    const loginResponse = await axios.post(`${API}/auth/login`, {
                      username: 'admin', password: 'password'
                    });
                    await axios.delete(`${API}/schedules/${schedule.id}`, {
                      headers: { Authorization: `Bearer ${loginResponse.data.token}` }
                    });
                    alert('Deleted successfully');
                    window.location.reload();
                  } catch (error) {
                    alert('Delete failed');
                  }
                }
              }}
              className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
            >
              DELETE THIS SHIFT
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DebugSchedule;